import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TokenStorageService } from '../services/helpers/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private tokenStorage: TokenStorageService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkAndRedirect(state.url);
  }
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = location.href;
    const redirectUrl = location.pathname;
    return this.checkAndRedirect(url, redirectUrl);
  }
  private checkAndRedirect(url, redirectUrl = null): any {
    this.parseUrlAndSave(url);

    if (!sessionStorage.getItem('authorization')) {
      return this.router.navigate(['auth/login']);
    } else {
      return true;
    }
  }

  parseUrlAndSave(url: string): void {
    const parsedUrl = new URL(url, window.location.origin);
    const token = parsedUrl.searchParams.get('token');
    const authorization = parsedUrl.searchParams.get('authorization');
    const account = parsedUrl.searchParams.get('account');
    if (token) {
      const parsedToken = JSON.parse(token);
      this.tokenStorage.saveToken(parsedToken.access_token);
      this.tokenStorage.saveRefreshToken(parsedToken.refresh_token);
      this.tokenStorage.saveUser(parsedToken);
      this.tokenStorage.saveExpireRefreshToken(parsedToken.refresh_expire.toString());
      this.tokenStorage.saveExpireToken(parsedToken.access_expire.toString());
      // sessionStorage.setItem('token', token);
    }
    if (authorization) {
      sessionStorage.setItem('authorization', 'true');
    }
    if (account) {
      sessionStorage.setItem('account', account);
    }
  }
}
